import React from 'react';
import { C } from '../../theme.js';
import { Eyebrow, IconButton } from '../../components/Primitives.jsx';
import { SOURCE_COLUMNS } from '../../data.js';
import { ColumnsContext } from '../StepInspector.jsx';

// Reorder always operates on self (this block's own incoming rows) — no
// Source selector, no Output Name field.
export function ReorderInspector({ step, onChange, columns }) {
  const ctxCols = React.useContext(ColumnsContext);
  const c = step.config || {};
  const cols = columns || ctxCols || SOURCE_COLUMNS;
  // Reconcile the saved order against the live columns every render, rather
  // than freezing on whatever `cols` looked like the first time the user
  // reordered anything — otherwise a column added by a later-added upstream
  // step (or renamed/removed) never shows up here, even though the backend
  // (s_reorder) already tolerates a stale/partial order and appends any
  // unlisted column at the end. Keep the saved relative order for columns
  // still present, then append any live column not yet in it (in live
  // order), so the user can see and actually position new columns instead
  // of them silently landing at the end.
  const liveNames = cols.map(co => co.name);
  const stored = c.order && c.order.length ? c.order.filter(n => liveNames.includes(n)) : [];
  const order = stored.concat(liveNames.filter(n => !stored.includes(n)));
  const u = (patch) => onChange({ ...step, config: { ...c, ...patch } });
  const move = (i, dir) => {
    const next = [...order];
    const j = i + dir;
    if (j < 0 || j >= next.length) return;
    [next[i], next[j]] = [next[j], next[i]];
    u({ order: next });
  };
  return (
    <div>
      <Eyebrow>Column order</Eyebrow>
      <div style={{ color: C.fg4, fontSize: '.78rem', margin: '4px 0 10px' }}>
        Drag to reorder · the preview will use this order in the table.
      </div>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
        {order.map((name, i) => (
          <div key={name} style={{
            display: 'flex', alignItems: 'center', gap: 8,
            background: C.input, border: `1px solid ${C.border}`,
            borderRadius: 6, padding: '6px 10px',
          }}>
            <span style={{ color: C.fg5, fontSize: '.7rem', fontFamily: "'JetBrains Mono', monospace", width: 18 }}>{i + 1}</span>
            <span style={{ color: C.fg2, fontSize: '.82rem', flex: 1, fontFamily: "'JetBrains Mono', monospace" }}>{name}</span>
            <IconButton title="Move up" onClick={() => move(i, -1)}>↑</IconButton>
            <IconButton title="Move down" onClick={() => move(i, +1)}>↓</IconButton>
          </div>
        ))}
      </div>
    </div>
  );
}
